import { action } from 'satcheljs';
/**
 * Called when there is a change in the forward meeting notification option
 */
var selectForwardMeetingNotificationOption = action('selectForwardMeetingNotificationOption', function (removeForwardedMeetingNotifications) { return ({
    removeForwardedMeetingNotifications: removeForwardedMeetingNotifications,
}); });
export default selectForwardMeetingNotificationOption;
//# sourceMappingURL=selectForwardMeetingNotificationOption.js.map